export const TEMPLATES_EDITOR_GUIDE = {
  'BASIC FULL COUNTDOWN': { guide: { imageType: ['Single'] } },
  'BOTTOM SHEET IMAGE': { guide: { imageType: ['Single, Multiple(2~7)'] } },
  'RADIUS MODAL SLIDE': { guide: { imageType: ['Single'] } },
  'FULL DUAL IMAGE': { guide: { imageType: ['Dual(2)'] } },
  'CAROUSEL SLIDE MODAL': {
    guide: {
      imageType: ['Multiple(3~10)'],
      multiGuide: ['Horizontal', 'Square', 'Vertical']
    }
  },
  'MODAL SLIDE': { guide: { imageType: ['Multiple(3~7)'] } },
  'AUTO SQUARE SLIDE': { guide: { imageType: ['Single, Mulitiple(2~10)'] } },
  'CHOICE BUTTON MODAL': {
    guide: {
      imageType: ['Single'],
      multiGuide: ['Single', 'Double']
    }
  },
  'SLIDE MODAL ROUND': { guide: { imageType: ['Single', 'Multiple(2~7)'] } },
  'SIMPLE MODAL SLIDE': { guide: { imageType: ['Single', 'Multiple(2~7)'] } },
  'BOTTOM SHEET SLIDE': { guide: { imageType: ['Single', 'Multiple(2~7)'] } },
  'BASIC FULL IMAGE': { guide: { imageType: ['Single'] } },
  'RADIUS FULL COUNTDOWN': { guide: { imageType: ['Single'] } },
  'SIMPLE MODAL': { guide: { imageType: ['Single'] } },
  'SLIDE FULL IMAGE': { guide: { imageType: ['Multiple(3~7)'] } },
  'SLIDE MODAL IMAGE': { guide: { imageType: ['Multiple(3~7)'] } },
  'AUTO MODAL SLIDE': { guide: { imageType: ['Multiple(3~7)'] } },
  'COUPON BOTTOM SHEET': { guide: { imageType: [''] } },
  'IMAGE BOTTOM SHEET': { guide: { imageType: ['Single'] } },
  'BOTTOM SLIDE UP': { guide: { imageType: ['Single'] } },
  'ALARM MODAL': { guide: { imageType: [''] } },
  'SIMPLE ICON MODAL': { guide: { imageType: ['Single'] } }
};
